// jsx/components/Scoring/UnconsciousBiasModal.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';

const UnconsciousBiasModal = ({ show, onHide, onTrainingComplete }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleContinue = () => {
    if (isChecked) {
      onTrainingComplete();
    }
  };

  const handleCancel = () => {
    setIsChecked(false);
    onHide();
  };

  const videoId = '99aimUNhdCU';
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Unconscious Bias Training</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="mb-4">
          <p className="mb-3">
            Prior to acceptance of scoring, you must have recently completed
            Unconscious Bias training.
          </p>

          <p className="mb-4">
            Please watch the Academy’s Unconscious Bias Training video below,
            then check the box to continue.
          </p>

          <div className="mb-4 mx-auto container-md px-0">
            <div className="ratio ratio-4x3">
              <iframe
                src={embedUrl}
                title="Academy Unconscious Bias Training"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded"
              />
            </div>
          </div>

          <Form.Group className="mb-0">
            <Form.Check
              type="checkbox"
              id="unconscious-bias-checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              label="I have viewed the Academy's Unconscious Bias training video in the past 2 years"
              className="fs-6"
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="success"
          className="standard-width-button"
          onClick={handleContinue}
          disabled={!isChecked}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

UnconsciousBiasModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onTrainingComplete: PropTypes.func.isRequired,
};

export default UnconsciousBiasModal;
